module.exports = __webpack_public_path__ + "img/aoi.5e22ac87.png";